import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"



export default function ModalFoto({ show, setShow, imgSrc, alternativo }) {
    const [zoom, setZoom] = useState(1)
    
    const handlerSimpleClose = () => setShow(last => ({ ...last, flag: false }))

    useEffect(() => {
        if (show) {
            setZoom(1)
        }
    }, [show, imgSrc])

    const zoomIn = () => setZoom(last => Math.min(Number((last + 0.25).toFixed(2)), 3))
    const zoomOut = () => setZoom(last => Math.max(Number((last - 0.25).toFixed(2)), 0.5))
    const resetZoom = () => setZoom(1)

    return (
        <>
            <Modal
                show={show}
                onHide={handlerSimpleClose}
                backdrop='static'
                keyboard={false}
                centered
                size='xl'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Foto Enviada</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        style={{
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: '75vh',
                            textAlign: 'center',
                            paddingTop: '56px'
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '50px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                flexWrap: 'nowrap',
                                alignItems: 'center',
                                gap: '2px',
                                zIndex: 2,
                                width: 'fit-content',
                                padding: '4px 8px',
                                borderRadius: '999px',
                                backgroundColor: '#ffffff',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
                            }}
                        >
                            <button
                                onClick={zoomOut}
                                title='Diminuir zoom'
                                style={{ width: '32px', height: '32px', fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, border: '0.1px solid #ccc' }}
                            >
                                <i className='bi bi-zoom-out' />
                            </button>
                            <span style={{ fontSize: '0.75rem', fontWeight: 600, minWidth: '36px', textAlign: 'center', color: '#333', userSelect: 'none' }}>
                                {Math.round(zoom * 100)}%
                            </span>
                            <button
                                onClick={zoomIn}
                                title='Aumentar zoom'
                                style={{ width: '32px', height: '32px', fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, border: '0.1px solid #ccc' }}
                            >
                                <i className='bi bi-zoom-in' />
                            </button>
                            <button
                                onClick={resetZoom}
                                title='Resetar zoom'
                                style={{ width: '32px', height: '32px', fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, border: '0.1px solid #ccc' }}
                            >
                                <i className='bi bi-aspect-ratio' />
                            </button>
                            <div style={{ width: '1px', height: '20px', backgroundColor: '#ddd', margin: '0 4px' }} />
                            <a
                                href={imgSrc}
                                target='_blank'
                                rel='noreferrer'
                                title='Abrir em tamanho real'
                                style={{ width: '32px', height: '32px', fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#333', textDecoration: 'none' }}
                            >
                                <i className='bi bi-box-arrow-up-right' />
                            </a>
                        </div>
                        <img
                            src={imgSrc}
                            alt={alternativo}
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                transform: `scale(${zoom})`,
                                transformOrigin: 'top center',
                                transition: 'transform 0.15s ease-out'
                            }}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
